import { createRouter, createWebHistory } from 'vue-router'
import { routes } from "./routes"
import { ISACTIVE } from '@/constants';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes, /* eslint-disable */
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

  },
})

router.beforeEach(async (to, from, next) => {
  const isActive = window.localStorage.getItem(ISACTIVE) === 'true'; // Ensure boolean comparison

  if (to.meta.auth) {
    // Route requires auth
    if ( !isActive) {
      next({ name: 'auth.subscribe' }); // Make sure this route exists
    } else {
      next();
    }
  } else {
    // Route does not require auth
    next();
  }
});





export default router



